import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../../../icon';
import { iconsList } from '../../../icon/glyphs';
import Text from '../../../text';
import { SIZES, APPEARANCES, TYPES } from './constants';
import { TYPES as ICON_APPEARANCES } from '../../../icon/constants';

const ListItem = ({
  children,
  size = SIZES.medium,
  appearance = APPEARANCES.highEmphasis,
  iconGlyph = null,
  iconAppearance = ICON_APPEARANCES.inherit,
  customIcon = null,
}) => {
  const classes = classNames('ws-ui-list-item', `ws-ui-list-item--${size}`, {
    'ws-ui-list-item--with-icon': iconGlyph,
  });

  return (
    <Text className={classes} type={TYPES.listItem} size={size} appearance={appearance}>
      {iconGlyph && (
        <div className="ws-ui-list-item__icon">
          <Icon glyph={iconGlyph} type={iconAppearance} size="100%" />
        </div>
      )}
      {customIcon}
      {children}
    </Text>
  );
};

ListItem.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(Object.values(SIZES)),
  appearance: PropTypes.oneOf(Object.values(APPEARANCES)),
  iconGlyph: PropTypes.oneOf(iconsList),
  iconAppearance: PropTypes.oneOf(Object.values(ICON_APPEARANCES)),
  customIcon: PropTypes.oneOfType([PropTypes.node, PropTypes.oneOf([null])]),
};

export default ListItem;
